import Cookies from "js-cookie";

const useCookie = () => {
  const getCookieOptions = () => ({
    expires: 1,
    sameSite: "lax",
    path: "/",
  });

  function getToken() {
    const tokenData = Cookies.get("i-tokens");
    if (!tokenData) return null;
    try {
      return JSON.parse(tokenData);
    } catch {
      Cookies.remove("i-tokens", { path: "/" });
      return null;
    }
  }

  function setToken(tokenObject) {
    Cookies.set("i-tokens", JSON.stringify(tokenObject), getCookieOptions());
  }

  function setTradingMode(mode) {
    Cookies.set("i-trading-mode", mode, getCookieOptions());
  }

  function getTradingMode() {
    return Cookies.get("i-trading-mode") || "PT";
  }

  function clearCookies() {
    Cookies.remove("i-tokens", { path: "/" });
    Cookies.remove("i-trading-mode", { path: "/" });
  }

  return { getToken, setToken, setTradingMode, getTradingMode, clearCookies };
};

export default useCookie;
